import EventsTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';
import PrimaryButton from 'components/form/buttons/primaryButton';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export default function EventsPage() {
  const { events } = useTypedSelector((state: any) => state.Events);
  const { departments } = useTypedSelector((state) => state.Departments);

  return (
    <S.Container>
      <PageTitle title="Events" />
      <S.Head>
        <PrimaryButton link="/panel/events/create">
          <PlusIcon />
          New event
        </PrimaryButton>
      </S.Head>
      <EventsTable data={events.data} departments={departments.data} loading={events.loading} />

      <AppLoading loading={departments.loading} />
    </S.Container>
  );
}
